export default "__VITE_ASSET__CgaLRIQa__"